import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { Button, Tooltip } from '@material-ui/core';

export const CopyToClipboardCustom = ({text}) => {
    const [copied, setCopied] = React.useState(false);

    return ( 
        <span style={{marginLeft: 25}}>
            <CopyToClipboard 
                text={text}
                onCopy={() => setCopied(true)}
            >
                <Tooltip title="Copiar">
                    <Button
                        style={{marginTop: -5}}
                    >
                        <FileCopyIcon fontSize="small"/>
                    </Button>
                </Tooltip>
            </CopyToClipboard>

            {copied ? <span style={{color: 'red', fontWeight: 900}}>Copiado!</span> : null}
        </span>
     );
}